import Chart from "chart.js/auto";

const MAX_LEGEND_LENGTH = 15;

const DoughnutChartHook = {
  mounted() {
    let palette = [
      "#2E54E3",
      "#2E54E3B3",
      "#2E54E370",
      "#2E54E34D",
      "#2E54E326",
    ];

    // This is a bunch of calculation stuff to draw the portfolio value on the canvas rather than as an HTML element.
    // This makes the styling a bit more complicated here, but in general a good deal more resilient.
    let innerTextPlugin = {
      beforeDraw: function (chart, args, options) {
        let width = chart.chartArea.width,
          height = chart.chartArea.height,
          ctx = chart.ctx;

        ctx.restore();
        ctx.fillStyle = "#101828";
        ctx.textAlign = "center";
        let fontSize = (height / 125).toFixed(2);
        ctx.font = "600" + " " + fontSize + "em Manrope";

        let statText = chart.data.interiorValue,
          textX = Math.round(width / 2),
          textY = height * 0.475;

        const estimatedChartLineWidth = 10;
        const maxWidth = Math.round(width / 2 - estimatedChartLineWidth);

        ctx.fillText(statText, textX, textY, maxWidth);
        ctx.save();

        fontSize = (height / 225).toFixed(2);
        ctx.font = "600" + " " + fontSize + "em Manrope ";
        ctx.fillStyle = "#667085";

        let captionText = chart.data.interiorSubtitle;

        textX = Math.round(width / 2);
        textY = height * 0.625;

        ctx.fillText(captionText, textX, textY);

        // Reset fill style
        ctx.fillStyle = "#667085";
        ctx.save();
      },
    };

    Chart.defaults.font.family = "Manrope";
    let ctx = this.el.getContext("2d");
    let chart = new Chart(ctx, {
      type: "doughnut",
      data: {
        interiorValue: "",
        interiorSubtitle: "",
        labels: [],
        datasets: [
          {
            label: "Total Portfolio Value",
            data: [],
            backgroundColor: palette,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        borderWidth: 2,
        cutout: "85%",
        plugins: {
          legend: {
            onClick: (event, legendItem, legend) => {},
            position: "bottom",
            labels: {
              generateLabels: (chart) =>
                chart.data.labels.map((label, i) => ({
                  datasetIndex: 0,
                  index: i,
                  text:
                    label.substr(0, MAX_LEGEND_LENGTH) +
                    (label.length > MAX_LEGEND_LENGTH ? "..." : ""),
                  fillStyle: chart.data.datasets[0].backgroundColor[i],
                  strokeStyle: chart.data.datasets[0].backgroundColor[i],
                  hidden: false,
                })),
              usePointStyle: true,
              pointStyle: "circle",
              boxWidth: 8,
              boxHeight: 8,
            },
          },
        },
      },
      plugins: [innerTextPlugin],
    });

    this.pushEvent("get-doughnut-graph-data");

    this.handleEvent(
      "doughnut_data",
      ({
        doughnut,
        interior_value: interiorValue,
        interior_subtitle: interiorSubtitle,
      }) => {
        chart.data.datasets[0].data = Object.values(doughnut);
        chart.data.labels = Object.keys(doughnut);

        // These aren't actual Chart.js values, but since this is Javascript we can do what
        // we want and just stick new keys in this object to be referenced in Chart.js
        // lifecycle plugins. Used to set custom interior text to be drawn to the canvas.
        chart.data.interiorValue = interiorValue;
        chart.data.interiorSubtitle = interiorSubtitle;

        chart.update();
      },
    );
  },
};

export { DoughnutChartHook };
